import { styled } from '../../../stitches.config';

export const Paragraph = styled('p', {
  margin: 0,
  color: '$purple12',
});
